"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectorChartPropsSize = exports.selectorChartMargin = exports.selectorChartDrawingArea = exports.selectorChartDimensionsState = exports.selectorChartContainerSize = void 0;
var _selectors = require("../../utils/selectors");
var _useChartAxisSize = require("../../featurePlugins/useChartCartesianAxis/useChartAxisSize.selectors");
const selectorChartDimensionsState = state => state.dimensions;
exports.selectorChartDimensionsState = selectorChartDimensionsState;
const selectorChartMargin = exports.selectorChartMargin = (0, _selectors.createSelector)(selectorChartDimensionsState, dimensionsState => dimensionsState.margin);
const selectorChartWidth = (0, _selectors.createSelector)(selectorChartDimensionsState, dimensionsState => dimensionsState.width);
const selectorChartHeight = (0, _selectors.createSelector)(selectorChartDimensionsState, dimensionsState => dimensionsState.height);
const selectorChartTopMargin = (0, _selectors.createSelector)(selectorChartMargin, margin => margin.top);
const selectorChartRightMargin = (0, _selectors.createSelector)(selectorChartMargin, margin => margin.right);
const selectorChartBottomMargin = (0, _selectors.createSelector)(selectorChartMargin, margin => margin.bottom);
const selectorChartLeftMargin = (0, _selectors.createSelector)(selectorChartMargin, margin => margin.left);
const selectorChartDrawingArea = exports.selectorChartDrawingArea = (0, _selectors.createSelector)(selectorChartWidth, selectorChartHeight, selectorChartTopMargin, selectorChartRightMargin, selectorChartBottomMargin, selectorChartLeftMargin, _useChartAxisSize.selectorChartTopAxisSize, _useChartAxisSize.selectorChartRightAxisSize, _useChartAxisSize.selectorChartBottomAxisSize, _useChartAxisSize.selectorChartLeftAxisSize, (width, height, marginTop, marginRight, marginBottom, marginLeft, axisSizeTop, axisSizeRight, axisSizeBottom, axisSizeLeft) => ({
  width: width - marginLeft - marginRight - axisSizeLeft - axisSizeRight,
  left: marginLeft + axisSizeLeft,
  right: marginRight + axisSizeRight,
  height: height - marginTop - marginBottom - axisSizeTop - axisSizeBottom,
  top: marginTop + axisSizeTop,
  bottom: marginBottom + axisSizeBottom
}));
const selectorChartPropsSize = exports.selectorChartPropsSize = (0, _selectors.createSelector)(selectorChartDimensionsState, dimensionsState => ({
  width: dimensionsState.propsWidth,
  height: dimensionsState.propsHeight
}));
const selectorChartContainerSize = exports.selectorChartContainerSize = (0, _selectors.createSelector)(selectorChartWidth, selectorChartHeight, (width, height) => ({
  width,
  height
}));